<template>
  <div id="standard-working-period" class="aisea-text-16-400-black">
    <v-select
      placeholder="-"
      class="standard-working-period-list"
      :options="displayStandardWorkPeriodList"
      v-model="selected"
      :clearable="false"
      :disabled="isDisabledList"
      @input="handleChange"
      style="min-width: 260px; max-height: 300px"
    >
      <template v-slot:no-options> - </template>
      <template #list-footer>
        <div
          v-if="showListFooter"
          class="show-list-label"
          @click="showAllLabor"
          @mouseover="mouseOverShowAllLabor"
        >
          全ての基準労働期間を表示
        </div>
      </template>
    </v-select>
    <dialog-standard-working-period-list
      ref="DialogStandardWorkingPeriodList"
      :inputStandardWorkingPeriod="handleChange"
      :enterpriseCrewId="enterpriseCrewId"
      :labors="labors"
    />
  </div>
</template>

<script>
import moment from "moment";
import { DateUtil } from "@/utils";
import vSelect from "vue-select";
import DialogStandardWorkingPeriodList from "./components/DialogStandardWorkingPeriodList";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
  "crewLabor"
);

export default {
  name: "StandardWorkingPeriod",
  mixins: [],
  components: {
    vSelect,
    DialogStandardWorkingPeriodList,
  },
  props: {
    standardWorkPeriodList: { Type: Array, default: [] },
    selectedStandardWorkPeriod: {
      Type: Object,
      required: false,
      default: () => {},
    },
    changeSelectedStandardWorkPeriod: {
      Type: Function,
      required: false,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    labors(val) {
      if (!val || val.length === 0) return;
      this.setTodayLaborSelected();
    },
    selectedStandardWorkPeriod(val) {
      if (!val) return;
      this.selected = val;
    },
    selected(val) {
      //基準労働期間が設定されている状態かつ当日の日付がない場合は、最新の基準労働期間を選択状態にする。
      if (!this.selected && this.labors.length > 0) {
        this.selected = this.labors[0];
        return;
      }
      this.changeSelectedStandardWorkPeriod(val);
    },
  },
  computed: {
    ...mapState(["enterpriseCrewId"]),
    labors() {
      if (this.standardWorkPeriodList.length === 0) return [];
      return this.standardWorkPeriodList.map(labor => {
        labor.label = `${labor.work_period_from} 〜 ${labor.work_period_to}`;
        labor.dispStandardWorkPeriod = `${labor.work_period_from} 〜 ${labor.work_period_to}`;
        return labor;
      });
    },
    displayStandardWorkPeriodList() {
      return this.labors.slice(0, 10);
    },
    showListFooter() {
      return this.labors.length > 10;
    },
    isDisabledList() {
      return this.labors.length === 0 || this.disabled;
    },
  },
  methods: {
    ...mapActions(["fetchLaborPeriodList"]),
    ...mapMutations(["SET_ENTERPRISE_CREW_ID"]),
    handleChange(nextStandardWorkPeriod) {
      this.selected = nextStandardWorkPeriod;
    },
    showCrewSidebarForPeriodList() {
      // 基準労働期間ダイアログを表示
      this.$refs.DialogStandardWorkingPeriodList.show();
    },
    mouseOverShowAllLabor() {
      const el = document
        .querySelector(".standard-working-period-list")
        .querySelector("ul")
        .querySelectorAll("li");
      el.forEach(item => {
        item.classList.remove("vs__dropdown-option--highlight");
        item.ariaSelected = null;
      });
    },
    showAllLabor() {
      this.showCrewSidebarForPeriodList();
    },

    async initWorkingPeriodList() {
      this.SET_ENTERPRISE_CREW_ID(this.$route.params.id);
      await this.fetchLaborPeriodList();
      this.setTodayLaborSelected();
    },

    setTodayLaborSelected() {
      this.selected = this.labors.find(item => {
        const today = moment().format("YYYY-MM-DD");
        return DateUtil.isBetween(
          today,
          item.work_period_from,
          item.work_period_to
        );
      });
    },
  },
  async mounted() {
    await this.initWorkingPeriodList();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#standard-working-period {
  .work-period-button {
    color: $aisea-gray;
    border: solid 1px $aisea-mouse-gray;
    border-radius: 4px;
    padding: 4px 8px;
  }

  .input-select-con > input {
    font-size: 16px;
  }

  .standard-working-period-list {
    width: 18rem;
    margin-top: 2px;

    .vs__selected {
      font-family: $aisea-font-family;
      font-size: 16px;
      font-weight: 400;
    }

    .vs__dropdown-menu {
      max-height: 324px;
    }

    .vs__dropdown-menu li {
      font-family: $aisea-font-family;
      font-size: 16px;
      font-weight: 400;
    }

    .vs__dropdown-option--highlight {
      background-color: $aisea-blue;
    }

    .show-list-label {
      cursor: pointer;
      padding: 4px 20px;
      font-size: 14px;
      color: $aisea-blue;
      &:hover {
        color: $aisea-pure-white;
        background-color: $aisea-blue;
      }
    }
  }
}
</style>
